import React from 'react';
import ErrorContainer from '../components/ErrorContainer';
import ErrorMessage from '../components/ErrorMessage';
import { FieldValidationErrorsType } from '../form/FrekulForm';

export type CustomSelectOptionType = {
  value: string,
  title: string,
};
export type CustomSelectOptionsType = CustomSelectOptionType[];

/**
 * select要素
 */
function CustomSelectView({
  options,
  value,
  setValue,
}: {
  options: CustomSelectOptionsType,
  value: string,
  setValue: (value: string) => void,
}) {
  return (
    <select value={value} onChange={(e) => setValue(e.target.value)}>
      <option
        value=""
      >
        選択してください
      </option>
      {options.map((option) => (
        <option
          key={option.value}
          value={option.value}
        >
          {option.title}
        </option>
      ))}
    </select>
  );
}

export default function CustomSelect({
  options,
  value,
  setValue,
  validationErrors = {},
}: {
  options: CustomSelectOptionsType,
  value: string,
  setValue: (value: string) => void,
  validationErrors?: FieldValidationErrorsType
}) {

  return (
    <>
      <ErrorContainer
        isValid={value !== '' && Object.keys(validationErrors).length === 0}
        isError={value !== '' && Object.keys(validationErrors).length > 0}
      >
        <CustomSelectView value={value} setValue={setValue} options={options} />
      </ErrorContainer>
      <ErrorMessage type="error" validationErrors={validationErrors} />
    </>
  );
}

